"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var api = _interopRequireWildcard(require("@/api/autoCacheSwitchApi"));
var _debounce = _interopRequireDefault(require("@/libs/debounce"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'autoCacheSwitch',
  data: function data() {
    return {
      form: {
        autoCacheEnabled: false,
        currentMode: 'hybrid'
      },
      metricsData: {
        currentQps: 0,
        currentActiveUsers: 0,
        windowSeconds: 60
      },
      thresholdData: {
        qpsOnThreshold: 100,
        qpsOffThreshold: 50,
        userOnThreshold: 50,
        userOffThreshold: 20
      },
      thresholdEdit: {
        qpsOnThreshold: 100,
        qpsOffThreshold: 50,
        userOnThreshold: 50,
        userOffThreshold: 20
      },
      thresholdSaving: false,
      thresholdEditing: false,
      switchList: [],
      logList: [],
      tableLoading: false,
      logLoading: false,
      unlockAllLoading: false,
      showGuide: true,
      refreshTimer: null,
      debouncedRefresh: null,
      // 开关管理弹窗
      switchDialog: false,
      switchDialogTitle: '新增缓存开关',
      switchDialogLoading: false,
      switchForm: {
        configKey: '',
        name: '',
        remark: '',
        sort: 99
      },
      switchFormRules: {
        configKey: [{
          required: true,
          message: '请输入开关标识',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入开关名称',
          trigger: 'blur'
        }]
      },
      modeOptions: [{
        value: 'manual',
        label: '手动模式',
        icon: 'el-icon-edit-outline',
        desc: '管理员完全掌控，系统不干预',
        color: '#fa8c16'
      }, {
        value: 'auto',
        label: '自动模式',
        icon: 'el-icon-cpu',
        desc: '系统根据并发量自动控制',
        color: '#52c41a'
      }, {
        value: 'hybrid',
        label: '混合模式',
        icon: 'el-icon-magic-stick',
        desc: '手动优先，自动辅助（推荐）',
        color: '#1890ff'
      }]
    };
  },
  computed: {
    qpsPercentage: function qpsPercentage() {
      var max = Math.max(this.thresholdData.qpsOnThreshold * 1.5, 1);
      return Math.min(100, (this.metricsData.currentQps || 0) / max * 100);
    },
    userPercentage: function userPercentage() {
      var max = Math.max(this.thresholdData.userOnThreshold * 1.5, 1);
      return Math.min(100, (this.metricsData.currentActiveUsers || 0) / max * 100);
    },
    qpsThresholdPos: function qpsThresholdPos() {
      return Math.min(100, this.thresholdData.qpsOnThreshold / (this.thresholdData.qpsOnThreshold * 1.5) * 100);
    },
    userThresholdPos: function userThresholdPos() {
      return Math.min(100, this.thresholdData.userOnThreshold / (this.thresholdData.userOnThreshold * 1.5) * 100);
    },
    thresholdMarkerPos: function thresholdMarkerPos() {
      return this.qpsThresholdPos;
    },
    isAboveQpsThreshold: function isAboveQpsThreshold() {
      return (this.metricsData.currentQps || 0) >= this.thresholdData.qpsOnThreshold;
    },
    isAboveUserThreshold: function isAboveUserThreshold() {
      return (this.metricsData.currentActiveUsers || 0) >= this.thresholdData.userOnThreshold;
    },
    hasAnyLocked: function hasAnyLocked() {
      return this.switchList.some(function (s) {
        return s.manuallyLocked;
      });
    },
    modeShortName: function modeShortName() {
      return {
        manual: '手动',
        auto: '自动',
        hybrid: '混合'
      }[this.form.currentMode] || '混合';
    }
  },
  created: function created() {
    var _this = this;
    this.debouncedRefresh = (0, _debounce.default)(this._getStatus, 500);
    this.debouncedRefresh();
    this.refreshTimer = setInterval(function () {
      _this.refreshMetrics();
    }, 10000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.refreshTimer) clearInterval(this.refreshTimer);
  },
  methods: {
    refresh: function refresh() {
      this.debouncedRefresh();
    },
    _getStatus: function _getStatus() {
      var _this2 = this;
      this.logLoading = true;
      this.tableLoading = true;
      api.getAutoCacheStatus().then(function (data) {
        _this2.logLoading = false;
        _this2.tableLoading = false;
        _this2.form.autoCacheEnabled = data.autoCacheEnabled;
        _this2.form.currentMode = data.currentMode;
        _this2.metricsData = {
          currentQps: data.currentQps,
          currentActiveUsers: data.currentActiveUsers,
          windowSeconds: data.windowSeconds
        };
        _this2.thresholdData = {
          qpsOnThreshold: data.qpsOnThreshold,
          qpsOffThreshold: data.qpsOffThreshold,
          userOnThreshold: data.userOnThreshold,
          userOffThreshold: data.userOffThreshold
        };
        if (!_this2.thresholdEditing) _this2.thresholdEdit = _objectSpread({}, _this2.thresholdData);
        _this2.switchList = _this2.buildSwitchList(data.switchStates);
        _this2.logList = data.recentLogs || [];
      }).catch(function () {
        _this2.logLoading = false;
        _this2.tableLoading = false;
      });
    },
    refreshMetrics: function refreshMetrics() {
      var _this3 = this;
      api.getAutoCacheMetrics().then(function (data) {
        _this3.metricsData = {
          currentQps: data.currentQps,
          currentActiveUsers: data.currentActiveUsers,
          windowSeconds: data.windowSeconds
        };
      }).catch(function () {});
    },
    buildSwitchList: function buildSwitchList(switchStates) {
      if (Array.isArray(switchStates)) return switchStates;
      return Object.keys(switchStates || {}).map(function (key) {
        return {
          configKey: key,
          name: switchStates[key].name || switchStates[key].description || key,
          state: switchStates[key].state,
          manuallyLocked: switchStates[key].manuallyLocked
        };
      });
    },
    onAutoCacheEnabledChange: function onAutoCacheEnabledChange(enabled) {
      var _this4 = this;
      api.setAutoCacheEnabled(enabled).then(function () {
        _this4.$message.success("\u81EA\u52A8\u7F13\u5B58\u529F\u80FD\u5DF2".concat(enabled ? '开启' : '关闭'));
        _this4.debouncedRefresh();
      }).catch(function () {
        _this4.form.autoCacheEnabled = !enabled;
      });
    },
    onModeChange: function onModeChange(mode) {
      var _this5 = this;
      if (mode === this.form.currentMode) return;
      this.$confirm("\u786E\u8BA4\u5207\u6362\u4E3A\u300C".concat(this.modeShortNameMap[mode], "\u300D\u6A21\u5F0F\uFF1F"), '切换运行模式', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        api.setAutoCacheMode(mode).then(function (res) {
          _this5.$message.success(res || "\u5DF2\u5207\u6362\u4E3A".concat(_this5.modeShortNameMap[mode]));
          _this5.debouncedRefresh();
        });
      }).catch(function () {});
    },
    onSwitchChange: function onSwitchChange(row) {
      var _this6 = this;
      var target = row.state === '1' ? '0' : '1';
      var label = target === '1' ? '开启' : '关闭';
      var note = this.form.currentMode === 'hybrid' ? "<br><br><span style=\"color:#fa8c16\">\u6CE8\u610F\uFF1A\u6DF7\u5408\u6A21\u5F0F\u4E0B\u624B\u52A8\u8BBE\u7F6E\u5C06\u89E6\u53D130\u5929\u9501\u5B9A\u3002</span>" : '';
      this.$confirm("\u786E\u8BA4".concat(label, "\u300C").concat(row.name, "\u300D\u7F13\u5B58\uFF1F").concat(note), "\u624B\u52A8".concat(label), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(function () {
        api.setAutoCacheSwitch(row.configKey, target).then(function (res) {
          _this6.$message.success(res || "\u5DF2".concat(label));
          _this6.debouncedRefresh();
        });
      }).catch(function () {});
    },
    onUnlock: function onUnlock(row) {
      var _this7 = this;
      this.$confirm("\u786E\u8BA4\u89E3\u9664\u300C".concat(row.name, "\u300D\u7684\u9501\u5B9A\uFF1F\u89E3\u9664\u540E\u8BE5\u5F00\u5173\u6062\u590D\u81EA\u52A8\u7BA1\u63A7\u3002"), '解除锁定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        api.unlockAutoCacheSwitch(row.configKey).then(function (res) {
          _this7.$message.success(res || '已解除锁定');
          _this7.debouncedRefresh();
        });
      }).catch(function () {});
    },
    unlockAll: function unlockAll() {
      var _this8 = this;
      this.$confirm('确认解除所有开关的锁定？所有开关将恢复自动管控。', '一键解除锁定', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this8.unlockAllLoading = true;
        api.unlockAllAutoCacheSwitch().then(function (res) {
          _this8.$message.success(res || '已解除所有锁定');
          _this8.unlockAllLoading = false;
          _this8.debouncedRefresh();
        }).catch(function () {
          _this8.unlockAllLoading = false;
        });
      }).catch(function () {});
    },
    onQuickAction: function onQuickAction(action) {
      var _this9 = this;
      var target = action === 'open-all' ? '1' : '0';
      var label = target === '1' ? '开启' : '关闭';
      var targets = this.switchList.filter(function (s) {
        return !s.manuallyLocked;
      });
      if (targets.length === 0) {
        this.$message.warning('所有开关均已锁定，请先解除锁定');
        return;
      }
      this.$confirm("\u786E\u8BA4".concat(label, "\u6240\u6709\u672A\u9501\u5B9A\u7684\u7F13\u5B58\u5F00\u5173\uFF08\u5171 ").concat(targets.length, " \u4E2A\uFF09\uFF1F"), "\u6279\u91CF".concat(label), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var done = 0;
        targets.forEach(function (row) {
          api.setAutoCacheSwitch(row.configKey, target).then(function () {
            done++;
            if (done === targets.length) {
              _this9.$message.success("\u5DF2".concat(label, "\u6240\u6709 ").concat(targets.length, " \u4E2A\u7F13\u5B58\u5F00\u5173"));
              _this9.debouncedRefresh();
            }
          });
        });
      }).catch(function () {});
    },
    openAddSwitchDialog: function openAddSwitchDialog() {
      this.switchForm = {
        configKey: '',
        name: '',
        remark: '',
        sort: 99
      };
      this.switchDialogTitle = '新增缓存开关';
      this.switchDialog = true;
    },
    openEditSwitchDialog: function openEditSwitchDialog(row) {
      this.switchForm = {
        configKey: row.configKey,
        name: row.name,
        remark: row.remark || '',
        sort: row.sort || 99
      };
      this.switchDialogTitle = '编辑缓存开关';
      this.switchDialog = true;
    },
    onSaveSwitch: function onSaveSwitch() {
      var _this0 = this;
      this.$refs.switchFormRef.validate(function (valid) {
        if (!valid) return;
        _this0.switchDialogLoading = true;
        var data = _objectSpread({}, _this0.switchForm);
        var isEdit = _this0.switchDialogTitle === '编辑缓存开关';
        var action = isEdit ? api.updateAutoCacheSwitch(data) : api.addAutoCacheSwitch(data);
        action.then(function (res) {
          _this0.$message.success(res || (isEdit ? '开关已更新' : '开关已添加'));
          _this0.switchDialog = false;
          _this0.debouncedRefresh();
        }).catch(function (err) {
          _this0.$message.error(err.msg || '操作失败');
        }).finally(function () {
          _this0.switchDialogLoading = false;
        });
      });
    },
    onDeleteSwitch: function onDeleteSwitch(row) {
      var _this1 = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u7F13\u5B58\u5F00\u5173\u300C".concat(row.name, "\u300D\uFF1F\u5220\u9664\u540E\u8BE5\u5F00\u5173\u7684\u6240\u6709\u72B6\u6001\u8BB0\u5F55\u5C06\u88AB\u6E05\u9664\u3002"), '删除确认', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(function () {
        api.deleteAutoCacheSwitch(row.configKey).then(function (res) {
          _this1.$message.success(res || '开关已删除');
          _this1.debouncedRefresh();
        }).catch(function (err) {
          _this1.$message.error(err.msg || '删除失败');
        });
      }).catch(function () {});
    },
    onThresholdEdit: function onThresholdEdit() {
      this.thresholdEdit = _objectSpread({}, this.thresholdData);
      this.thresholdEditing = true;
    },
    onThresholdCancel: function onThresholdCancel() {
      this.thresholdEditing = false;
    },
    onThresholdSave: function onThresholdSave() {
      var _this10 = this;
      if (this.thresholdEdit.qpsOffThreshold >= this.thresholdEdit.qpsOnThreshold) {
        this.$message.warning('QPS 关闭阈值必须小于 QPS 开启阈值');
        return;
      }
      if (this.thresholdEdit.userOffThreshold >= this.thresholdEdit.userOnThreshold) {
        this.$message.warning('活跃用户关闭阈值必须小于活跃用户开启阈值');
        return;
      }
      this.thresholdSaving = true;
      api.updateAutoCacheThreshold(this.thresholdEdit).then(function (res) {
        _this10.$message.success(res || '阈值配置已保存');
        _this10.thresholdSaving = false;
        _this10.thresholdEditing = false;
        _this10.thresholdData = _objectSpread({}, _this10.thresholdEdit);
        _this10.debouncedRefresh();
      }).catch(function () {
        _this10.thresholdSaving = false;
      });
    },
    getSwitchRowClassName: function getSwitchRowClassName(_ref) {
      var row = _ref.row;
      return row.manuallyLocked ? 'switch-row-locked' : '';
    },
    handleSwitchCommand: function handleSwitchCommand(cmd, row) {
      switch (cmd) {
        case 'edit':
          this.openEditSwitchDialog(row);
          break;
        case 'delete':
          this.onDeleteSwitch(row);
          break;
        case 'unlock':
          this.onUnlock(row);
          break;
      }
    },
    getSwitchName: function getSwitchName(key) {
      return {
        index_cache_switch: '首页',
        user_center_cache_switch: '用户中心',
        product_list_cache_switch: '商品列表',
        coupon_list_cache_switch: '优惠券列表'
      }[key] || key;
    },
    formatTime: function formatTime(ts) {
      if (!ts) return '-';
      var d = new Date(ts),
        p = function p(n) {
          return String(n).padStart(2, '0');
        };
      return "".concat(d.getFullYear(), "-").concat(p(d.getMonth() + 1), "-").concat(p(d.getDate()), " ").concat(p(d.getHours()), ":").concat(p(d.getMinutes()), ":").concat(p(d.getSeconds()));
    },
    modeName: function modeName(mode) {
      if (mode === null || mode === undefined || mode === 'null' || mode === '') return '-';
      return {
        manual: '手动',
        auto: '自动',
        hybrid: '混合'
      }[mode] || mode;
    },
    modeTagType: function modeTagType(mode) {
      if (mode === null || mode === undefined || mode === 'null' || mode === '') return 'info';
      return {
        manual: 'warning',
        auto: 'success',
        hybrid: 'primary'
      }[mode] || 'info';
    },
    get modeShortNameMap() {
      return {
        manual: '手动模式',
        auto: '自动模式',
        hybrid: '混合模式'
      };
    }
  }
};